module.exports = __webpack_public_path__ + "static/media/filePetitions-min.a5bd1c40.jpg";